<template>
  <div>
    <ui-heading tag="h3" no-top-margin>
      {{ checks.label }}
    </ui-heading>
    <ul class="list">
      <li v-for="item in checks.items" :key="item.key" class="item">
        <icon name="check-circle" v-if="item.success" class="icon success" />
        <icon name="alert-circle" v-else-if="item.fail" class="icon fail" />
        <icon name="alert-circle" v-else class="icon unavailable" />
        <checks-item :item="item" />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";
import { CHECK_STATUS } from "@/router/constants";
import { getReasonsLabels } from "@/utils/checks";
import ChecksItem from "./ChecksItem.vue";

export default {
  components: { ChecksItem },
  computed: {
    ...mapGetters([getters.currentIdentification]),

    checks() {
      const { fraudChecks } = this.currentIdentification?.data ?? {};

      if (!fraudChecks?.length) {
        return [];
      }

      return {
        label: this.$t("checks_fraud_heading"),
        items: fraudChecks.map(rule => ({
          key: rule.name,
          label: this.$tIf({
            key: `checks_fraud.${rule.name}_${rule.status}`
          }),
          reasonLabels: getReasonsLabels(
            rule.reasons,
            "checks_fraud_reason",
            this.$tIf
          ),
          success: rule.status === CHECK_STATUS.SUCCESS,
          unavailable: rule.status === CHECK_STATUS.UNAVAILABLE,
          fail: rule.status === CHECK_STATUS.FAIL
        }))
      };
    }
  }
};
</script>

<style scoped lang="scss">
.list {
  padding: 0;
  margin: 0;
  font-size: 1rem;
  list-style: none;
}
.item {
  position: relative;
  padding-left: 1.5rem;

  & + & {
    margin-top: 0.5rem;
  }
}
.icon {
  position: absolute;
  left: 0;
  width: 1.2rem;
  height: 1.2rem;
  &.success {
    fill: var(--text-success);
  }
  &.unavailable {
    fill: var(--text-warning);
  }
  &.fail {
    fill: var(--text-danger);
  }
}
.info-link {
  display: inline-block;
}
.link-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: bottom;
}
.refresh-button.refresh-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.5em;
  padding: 0 0 0 0.5em;
  vertical-align: bottom;
}
.refresh-icon {
  width: 1.5rem;
}
</style>
